import { FeaturedIconV2 } from "./FeaturedIcon";
import { Player } from "@lottiefiles/react-lottie-player";
import LoadingCystack2Json from "#src/assets/images/animations/loading-cystack-2.json";
import { useTranslation } from "react-i18next";

interface IUploadButtonV2Props {
  accept: string;
  className?: string;
  description?: string;
  iconClassName?: string;
  loading?: boolean;
  onUpload: (v: any) => void
}

export const UploadButtonV2 = ({
  accept = "image/*",
  className = "",
  description = "SVG, PNG, JPG or GIF (max. 800x400px)",
  iconClassName = "",
  loading = true,
  onUpload = () => {},
}: IUploadButtonV2Props) => {
  const { t } = useTranslation("common", { keyPrefix: "v2.upload" });
  return (
    <label className={`bg-white rounded-xl border border-gray-v2-200 cursor-pointer ${className}`}>
      <input
        id="avatar_uploader"
        type="file"
        className="hidden"
        accept={accept}
        onChange={(e) => {
          if (e.currentTarget.files) {
            onUpload(Array.from(e.currentTarget.files));
          }
        }}
      />
      
      <div className={`flex justify-center flex-col px-6 pb-4 pt-1 gap-3 ${loading ? 'pt-4' : 'pt-1'}`}>
        <div className="text-center">
          {
            loading ? <Player
              autoplay
              loop
              src={LoadingCystack2Json}
              className="h-12 w-12"
            ></Player> : <FeaturedIconV2
              name="upload-cloud-02"
              iconClassName={iconClassName}
            />
          }
        </div>
        <div className="flex flex-col gap-1">
          <p className="flex gap-1 justify-center">
            <span className="text-sm font-semibold text-brand-v2-700">{t("button")}</span>
            <span className="text-sm font-regular text-gray-v2-600">{t("note")}</span>
          </p>
          <p className="text-xs font-regular text-gray-v2-600 text-center">{description}</p>
        </div>
      </div>
    </label>
  );
};
